__turbopack_context__.v({
  "addRoomBtn": "BookingModal-module__2WXnYa__addRoomBtn",
  "addRoomRow": "BookingModal-module__2WXnYa__addRoomRow",
  "ageBlock": "BookingModal-module__2WXnYa__ageBlock",
  "ageBtn": "BookingModal-module__2WXnYa__ageBtn",
  "ageBtnActive": "BookingModal-module__2WXnYa__ageBtnActive",
  "ageRow": "BookingModal-module__2WXnYa__ageRow",
  "body": "BookingModal-module__2WXnYa__body",
  "calculateBtn": "BookingModal-module__2WXnYa__calculateBtn",
  "changeBtn": "BookingModal-module__2WXnYa__changeBtn",
  "closeBtn": "BookingModal-module__2WXnYa__closeBtn",
  "counter": "BookingModal-module__2WXnYa__counter",
  "counterField": "BookingModal-module__2WXnYa__counterField",
  "counters": "BookingModal-module__2WXnYa__counters",
  "dateIcon": "BookingModal-module__2WXnYa__dateIcon",
  "dateInput": "BookingModal-module__2WXnYa__dateInput",
  "dateWrap": "BookingModal-module__2WXnYa__dateWrap",
  "deleteRoomBtn": "BookingModal-module__2WXnYa__deleteRoomBtn",
  "errorText": "BookingModal-module__2WXnYa__errorText",
  "field": "BookingModal-module__2WXnYa__field",
  "fieldLabel": "BookingModal-module__2WXnYa__fieldLabel",
  "fixedDate": "BookingModal-module__2WXnYa__fixedDate",
  "guestWarn": "BookingModal-module__2WXnYa__guestWarn",
  "header": "BookingModal-module__2WXnYa__header",
  "itinerary": "BookingModal-module__2WXnYa__itinerary",
  "modal": "BookingModal-module__2WXnYa__modal",
  "modalFooter": "BookingModal-module__2WXnYa__modalFooter",
  "modalScroll": "BookingModal-module__2WXnYa__modalScroll",
  "overlay": "BookingModal-module__2WXnYa__overlay",
  "packageInfo": "BookingModal-module__2WXnYa__packageInfo",
  "packageRow": "BookingModal-module__2WXnYa__packageRow",
  "placeholder": "BookingModal-module__2WXnYa__placeholder",
  "plus": "BookingModal-module__2WXnYa__plus",
  "priceCard": "BookingModal-module__2WXnYa__priceCard",
  "roomTab": "BookingModal-module__2WXnYa__roomTab",
  "roomTabActive": "BookingModal-module__2WXnYa__roomTabActive",
  "roomTabs": "BookingModal-module__2WXnYa__roomTabs",
  "roomTabsList": "BookingModal-module__2WXnYa__roomTabsList",
  "root": "BookingModal-module__2WXnYa__root",
  "secondaryBtn": "BookingModal-module__2WXnYa__secondaryBtn",
  "sheetUp": "BookingModal-module__2WXnYa__sheetUp",
  "slab": "BookingModal-module__2WXnYa__slab",
  "summary": "BookingModal-module__2WXnYa__summary",
  "summaryActions": "BookingModal-module__2WXnYa__summaryActions",
  "summaryBox": "BookingModal-module__2WXnYa__summaryBox",
  "summaryBoxLabel": "BookingModal-module__2WXnYa__summaryBoxLabel",
  "summaryContent": "BookingModal-module__2WXnYa__summaryContent",
  "summaryText": "BookingModal-module__2WXnYa__summaryText",
  "thumb": "BookingModal-module__2WXnYa__thumb",
  "title": "BookingModal-module__2WXnYa__title",
});
